import React from "react";
import "./vehicleItemList.css";

const VehicleListItem = ({ vehicle, isSelected, onSelect }) => {
  const isMoving = vehicle.speed > 0;

  return (
    <div
      className={`vehicle-list-item ${isSelected ? "selected" : ""}`}
      onClick={onSelect}
    >
      <div className="item-header">
        <strong className="vehicle-number">{vehicle.vehicleregnumber}</strong>
        <span className={`status-dot ${isMoving ? "moving" : "stopped"}`}></span>
      </div>

      <div className="item-details">
        <div className="detail-item">
          <span className="detail-label">Speed:</span>
          <span className="detail-value">{vehicle.speed} km/h</span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Status:</span>
          <span
            className={`status-text ${isMoving ? "moving" : "stopped"}`}
          >
            {isMoving ? "Moving" : "Stopped"}
          </span>
        </div>
      </div>

      {vehicle.lastUpdated && (
        <div className="item-footer">
          <span className="last-updated">
            Updated: {new Date(vehicle.lastUpdated).toLocaleTimeString()}
          </span>
        </div>
      )}
    </div>
  );
};

export default VehicleListItem;